import tw, { styled } from 'twin.macro';
import Button from '../Button/Button';

export const StyledWeekNavigation = styled.div.attrs((props) => ({
  className: props.className
  /* The background style prevents the previous element of being visible when crossfading between weeks.
   * It has the same background color value as the YesplanAppFrame background
   */
}))(() => [tw`flex items-center justify-center bg-silver-lighten-30`]);

export const StyledWeekNavigationButton = styled(Button).attrs((props) => ({
  contentType: 'icon',
  icon: props.icon,
  size: 'medium'
}))(({ $datepickerIsOpen }) => [$datepickerIsOpen && tw`invisible`]);

export default StyledWeekNavigation;
